<template>
    <div>
        <!--新增Password弹框-->
        <el-dialog :title="$t('AddPasswordUnlock')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="addPassword.addPasswordFrom" 
            center 
            :show-close="addPassword.showClose" 
        >
            <div class="addsiteUersBox">
                <div class="addSiteUserLeft">
                    <el-form>
                        <el-form-item :label="$t('Name') + ' *'">
                            <el-input v-model="addPassword.title" autocomplete="off"></el-input>
                        </el-form-item>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('PasswordUnlock') + ' *'">
                                    <el-input :type="addPassword.passwordFlage" v-model="addPassword.payload" autocomplete="new-password">
                                        <i slot="suffix" class="el-input__icon" @click="changePasswordShow">
                                            <img style="width: 20px;margin-top: 10px; margin-right: 10px;" :src="addPassword.passwordImg" alt="">
                                        </i>
                                    </el-input>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockOption') + ' *'">
                                    <el-select style="width: 100%;" v-model="addPassword.locks" multiple :placeholder="$t('PleaseSelect')">
                                        <el-option
                                        v-for="item in addPassword.locksOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top:20px;padding-top:20px;">
                            <div class="LimitBox">
                                <div style="width:48%;">
                                    <el-form-item :label="$t('Limited')" label-width="100px">
                                        <el-input v-model="addPassword.countLimit" :disabled="addPassword.countLimitDis"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('NumbeOfUses')}}</span>
                                </div>
                            </div>
                            <div class="LimitBox">
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('Unlinmited')}}</span>
                                </div>
                                <div class="cardText">
                                    <el-switch
                                    @change="addPasswordUnlinmitChage"
                                    v-model="addPassword.Unlinmited">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top: 10px;border-bottom: 1px solid #ddd; padding-top:20px;padding-bottom:30px;">
                            <div class="LimitBox">
                                <div>
                                    <el-form-item :label="$t('ValidityTime')" :title="$t('ValidityTime')" class="ValidityTimeLable" label-width="120px">
                                        <el-date-picker
                                        :disabled="addPassword.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="addPassword.startTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('StartTime')">
                                        </el-date-picker> ~ 
                                        <el-date-picker
                                        :disabled="addPassword.isFovever"
                                        style="width: 46%;font-size:14px;"
                                        v-model="addPassword.endTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('EndTime')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="FoveverBox">
                                <div style="padding-right: 20px; margin-top: 20px;color: #333;">
                                    <el-form-item :label="$t('Forever')" :title="$t('Forever')" class="ValidityTimeLable" label-width="120px">
                                        <el-switch
                                            @change="addPasswordForeverChage"
                                            v-model="addPassword.fovever">
                                        </el-switch>
                                    </el-form-item>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </el-form>
                </div>
                <div class="addSiteUserRight">
                    <div>{{$t('PanelSync')}}</div>
                    <div class="licenseBox" style="height: 380px;">
                        <div v-for="item in addPassword.devList" :key="item.id" style="margin-bottom: 5px">
                            <el-checkbox  v-model="item.isChecked">{{item.deviceName}}</el-checkbox>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer addCard">
                <el-button @click="addPassword.addPasswordFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" :loading="addPassword.addBtnState === 1" class="selectBtn" style="margin-left: 60px !important" @click="addPasswordUnlock">{{$t('Confirm')}}</el-button>
            </div>
        </el-dialog>
        <!--编辑Password弹框-->
        <el-dialog :title="$t('EditPasswordUnlock')" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false" 
            :visible.sync="editPassword.editPasswordFrom" 
            center 
            :show-close="editPassword.showClose" 
        >
            <div class="addsiteUersBox">
                <div class="addSiteUserLeft">
                    <el-form>
                        <el-form-item :label="$t('Name')  + ' *'">
                            <el-input v-model="editPassword.title"></el-input>
                        </el-form-item>
                        <div class="NameBox">
                            <div style="width:48%">
                                <el-form-item :label="$t('PasswordUnlock') + ' *'">
                                <el-input type="text" disabled v-model="editPassword.payload"></el-input>
                                </el-form-item>
                            </div>
                            <div style="width:48%">
                                <el-form-item :label="$t('UnlockOption') + ' *'">
                                    <el-select disabled style="width: 100%;" v-model="editPassword.locks" multiple :placeholder="$t('PleaseSelect')">
                                        <el-option
                                        v-for="item in editPassword.locksOptions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                        </el-option>
                                    </el-select>
                            </el-form-item>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top:20px;padding-top:20px;">
                            <div class="LimitBox">
                                <div style="width:48%;">
                                    <el-form-item :label="$t('Limited')" label-width="100px">
                                        <el-input v-model="editPassword.countLimit" disabled></el-input>
                                    </el-form-item>
                                </div>
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('NumbeOfUses')}}</span>
                                </div>
                            </div>
                            <div class="LimitBox">
                                <div class="cardText">
                                    <span style="font-size: 16px;">{{$t('Unlinmited')}}</span>
                                </div>
                                <div class="cardText">
                                    <el-switch
                                    disabled
                                    @change="editPasswordUnlinmitChage"
                                    v-model="editPassword.Unlinmited">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="LimitContent" style="margin-top: 10px;border-bottom: 1px solid #ddd; padding-top:20px;padding-bottom:30px;">
                            <div class="LimitBox">
                                <div>
                                    <el-form-item :label="$t('ValidityTime')" :title="$t('ValidityTime')" class="ValidityTimeLable" label-width="120px">
                                        <el-date-picker
                                        disabled
                                        style="width: 46%; font-size:14px;"
                                        v-model="editPassword.startTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('StartTime')">
                                        </el-date-picker> ~ 
                                        <el-date-picker
                                        disabled
                                        style="width: 46%;font-size:14px;"
                                        v-model="editPassword.endTime"
                                        type="datetime"
                                        value-format="timestamp"
                                        :placeholder="$t('EndTime')">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="FoveverBox">
                                <div style="padding-right: 20px; margin-top: 20px;color: #333;">
                                    <el-form-item :label="$t('Forever')" :title="$t('Forever')" class="ValidityTimeLable" label-width="120px">
                                        <el-switch
                                            disabled
                                            @change="editPasswordForeverChage"
                                            v-model="editPassword.fovever">
                                        </el-switch>
                                    </el-form-item>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </el-form>
                </div>
                <div class="addSiteUserRight">
                    <div>{{$t('PanelSync')}}</div>
                    <div class="licenseBox" style="height: 380px;">
                        <div v-for="item in editPassword.devList" :key="item.id" style="margin-bottom: 5px;display:flex;justify-content: space-between;">
                            <el-checkbox  v-model="item.isChecked">{{item.deviceName}}</el-checkbox>
                            <div v-show="item.isChecked" style="color:#999;font-size:14px;">{{handPanelApplyStatus(item.applyStatus)}}</div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer addCard">
                <el-button @click="editPassword.editPasswordFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" :loading="editPassword.editBtnState === 1" class="selectBtn" style="margin-left: 60px !important" @click="editPasswordUnlock">{{$t('Confirm')}}</el-button>
            </div>
        </el-dialog>
        <!--删除Password弹框-->
        <el-dialog
            :title="$t('Delete')"
            :visible.sync="delPassword.delPasswordFrom"
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            width="500px"
            :show-close="delPassword.showClose">
            <p class="deleteDesc">{{$t('ConfirmDeletePassword')}}</p>
            <span slot="footer" class="dialog-footer addCard">
                <el-button @click="delPassword.delPasswordFrom = false">{{$t('Cancel')}}</el-button>
                <el-button type="primary" class="selectBtn" style="margin-left: 60px !important" :loading="delPassword.delBtnState === 1" @click="delPasswordSetting">{{$t('Confirm')}}</el-button>
            </span>
        </el-dialog>
        <div class="noSipsettings" v-show="password.hasNoPassword">{{$t('NoData')}}!</div>
        <template>
            <el-table
            v-show="!password.hasNoPassword"
            :data="password.passwordList"
            style="width: 100%;"
            :header-cell-style="{background:'#EDEFFB',color:'#4D4D4F'}"
            >
                <el-table-column
                    label="#"
                    type="index"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="title"
                    :label="$t('Name')"
                    >
                </el-table-column>
                <el-table-column
                    prop="locks"
                    :label="$t('LockTemplate')"
                    >
                </el-table-column>
                
                <!-- <el-table-column
                    prop="payload"
                    :label="$t('PassWord')"
                    >
                    <template slot-scope="scope">
                        {{decryptPasswordUnlock(scope.row.payload)}}
                    </template>
                </el-table-column> -->
                <el-table-column
                    prop="countLimit"
                    :label="$t('LimitedUse')"
                    >
                    <template slot-scope="scope">
                        {{handCountLimit(scope.row.countLimit,scope.row.usedCount)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="startTime"
                    :label="$t('ValidityTime')"
                    >
                    <template slot-scope="scope">
                        {{validityTime(scope.row.startTime,scope.row.endTime)}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="entranceDeviceIds"
                    :label="$t('PanelSync')"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        {{showPanelsName(scope.row.entranceDeviceIds)}}
                    </template>
                </el-table-column>
                <el-table-column width="150"  label="..." align="center">
                    <template slot-scope="scope">
                        <el-image :src="password.editImg" :title="$t('Edit')"  @click="editPasswordSetting(scope.row)" style="width:24px;" fit="fill"></el-image>
                        <el-image :src="password.deleteImg" :title="$t('Delete')"  @click="openDelPasswordFrom(scope.row)" style="width:24px;margin-left:1vw" fit="fill"></el-image>
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
  
</template>

<script>
import CryptoJS from 'crypto-js';
import { encryptCBC, decryptCBC } from "@/util/aes";
import { mapState } from 'vuex';
import sitesUsersApi from '@/api/siteusers/index.js'
import showPassword from '@/assets/images/password_show.png'
import hidePassword from '@/assets/images/password_hide.png'
import editImg from '@/assets/images/edit.png'
import deleteImg from '@/assets/images/delete.png'
export default {
    name:"PasswordUnlock",
    data(){
        return{
            updateSiteUser:{
                id:"",
                userId:"",
            },
            password:{
                hasNoPassword:false,
                passwordList:[],
                editImg,
                deleteImg,
            },
            addPassword:{
                addPasswordFrom:false,
                showClose:true,
                title:"",
                // addCardType:"",
                passwordFlage:"password",
                passwordImg:hidePassword,
                showPassword,
                hidePassword,
                payload:"",
                locks:"",
                locksOptions:[
                    {
                        id:"1",
                        name:"Lock 1"
                    },
                    {
                        id:"2",
                        name:"Lock 2"
                    },
                ],
                countLimitDis:false,
                countLimit:"",
                Unlinmited:false,
                devList:[],
                startTime:"",
                endTime:"",
                isFovever:false,
                fovever:false,
                addBtnState:0,
            },
            editPassword:{
                editPasswordFrom:false,
                showClose:true,
                entranceKeyId:"",
                title:"",
                payload:"",
                locks:"",
                locksOptions:[
                    {
                        id:"1",
                        name:"Lock 1"
                    },
                    {
                        id:"2",
                        name:"Lock 2"
                    },
                ],
                countLimitDis:false,
                countLimit:1,
                Unlinmited:false,
                devList:[],
                entranceDeviceList:[],
                startTime:"",
                endTime:"",
                isFovever:false,
                fovever:false,
                userId:"",
                editBtnState:0,
            },
            delPassword:{
                delPasswordFrom:false,
                showClose:true,
                entranceKeyId:"",
                delBtnState:0,
            },
        }
    },
    mounted(){
       this.updateSiteUser.id = this.$route.params.id;
       this.updateSiteUser.userId = this.$route.params.userId;
    //    console.log("this.$route.params",this.$route.params,this.updateSiteUser.id);
       this.getSiteUserPasswordDevicesList();
       //获取uesr Password 配置列表
       this.getSiteUserPasswordList();
    },
    methods:{
        //10进制转为16进制
        decimalToHex(decimal) {
            return decimal.toString(16).toUpperCase();
        },
        //16进制转为10进制
        hexToDecimal(hexString) {
            return parseInt(hexString, 16);
        },
        //base64转为16进制字符串
        base64ToHex(base64String) {
            // 解码Base64字符串
            const byteArray = atob(base64String)
                .split('')
                .map(char => char.charCodeAt(0));
            
            // 转换为16进制字符串
            return byteArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
        },
        //字符串前面补0，直到满足长度要求
        padStringToLength(str, desiredLength) {
            return str.padStart(desiredLength, '0');
        },
        //字节数组转为16进制字符串
        byteToHex(arr) {
            let hexStr = "";
            for (let i = 0; i < arr.length; i++) {
                let hex = arr[i].toString(16);
                if (hex.length === 1) {
                hex = "0" + hex;
                }
                hexStr += hex;
            }
            return hexStr;
        },
        //16进制转base64
        hexStringToBase64(hexString) {
            // 将16进制字符串转换为Uint8Array
            const byteArray = new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
            
            // 使用btoa将二进制数据转换为Base64字符串
            const base64String = btoa(String.fromCharCode(...byteArray));
            
            return base64String;
        },
        //HmacSHA1签名函数
        Hmacstr(sigstr, key) {
            let result = CryptoJS.HmacSHA1(sigstr, key);
            let sig = result.toString(CryptoJS.enc.Hex);
            return sig;
        },
        //查询住宅有权限设备列表
        getSiteUserPasswordDevicesList(){
            let devicesInfoObj = {
                "rgn":this.selectCompany.companyRegion,
                "siteId":this.selectSite.id,
                "userHouseId":this.updateSiteUser.id,
                "pageSize":-1,
                "pageNum":1,
            }
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return
            }
            sitesUsersApi.getSiteUserDevicesList(devicesInfoObj).then(res => {
                if(res.code === 0){
                    this.addPassword.devList = [];
                    this.editPassword.devList = [];
                    if(res.data === null || res.data.list.length === 0){
                        this.addPassword.devList = [];
                        this.editPassword.devList = [];
                    }else{
                        res.data.list.forEach(item => {
                            if(item.accessStatus === 1 && this.$getBit(this.$base64ToByteArray(item.entranceAbility), 4) === 1){
                                item.isChecked = false;
                                this.addPassword.devList.push(item);
                                this.editPassword.devList.push(item);
                            }
                            
                        })
                    }
                }else{
                    this.addPassword.devList = [];
                    this.editPassword.devList = [];
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.addPassword.devList = [];
                this.editPassword.devList = [];
                // console.log(err);
            })
        },
        //查询用户Password Unlock列表
        getSiteUserPasswordList(){
            let passwordInfoObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let passwordPostObj = {
                "userHouseId":this.updateSiteUser.id,
                "userId":this.updateSiteUser.userId,
                "type":1,
            }
            //解决当前页面刷新后，由于路由参数改变导致updateSiteUser.id获取不到，获取用户密码配置命令出错 code:8
            if(!this.updateSiteUser.id){
                return
            }
            sitesUsersApi.getSiteUserCardConfigList(passwordInfoObj,passwordPostObj).then(res => {
                if(res.code === 0){
                    this.password.passwordList = [];
                    if(res.data === null || res.data.length === 0){
                        this.password.passwordList = [];
                        this.password.hasNoPassword = true;
                    }else{
                        this.password.hasNoPassword = false;
                        for(let i=0;i<res.data.length;i++){
                            this.password.passwordList.push(res.data[i]);
                        }
                    }
                }else{
                    this.password.passwordList = [];
                    this.password.hasNoPassword = true;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                this.password.passwordList = [];
                this.password.hasNoPassword = true;
                console.log(err);
            })
        },
        //解密密码
        decryptPasswordUnlock(cardVal){
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            //把获取到的16进制的字符串转为base64
            let base64Str = this.hexStringToBase64(cardVal);
            // console.log("cardVal",cardVal)
            // console.log("base64Str",base64Str)
            //解密之后密码
            let cardNumHex = decryptCBC(base64Str,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            // console.log("cardNumHex",cardNumHex)
            return cardNumHex
        },
        //处理次数
        handCountLimit(count,usedCount){
            let countLimitStr = "";
            if(count === 0){
                countLimitStr = this.$t('Unlinmited');
            }else{
                countLimitStr = usedCount + "/" + count;
            }
            return countLimitStr
        },
        //处理有效期
        validityTime(start,end){
            let validityStr = "";
            if(start === 0 && end === 0){
                validityStr = this.$t('Forever');
            }else{
                validityStr = this.utctolocal(start) + " ~ " + this.utctolocal(end);
            }
            return validityStr
        },
         //panels 名称显示
         showPanelsName(panelList){
            let panelStr = "";
            if(this.addPassword.devList.length != 0){
                this.addPassword.devList.map(item =>{
                    panelList.map(item2 =>{
                        if(item.id === item2){
                            panelStr += item.deviceName +  "\u2003"
                        }
                    })
                })
            }
            return panelStr;
        },
         //处理设备应用状态函数
         handPanelApplyStatus(statu){
            let statuStr = "";
           switch (statu) {
            case 0:
                statuStr = this.$t('NotApplied');
                break;
            case 1:
                statuStr = this.$t('ApplicationComplete');
                break;
            case 2:
                statuStr = this.$t('DataValidationFailed');
                break;
            case 3:
                statuStr = this.$t('TypesNotSupported');
                break;
            case 4:
                statuStr = this.$t('DeviceLimitedInput');
                break;
            case 5:
                statuStr = this.$t('DeviceDataDuplication');
                break;
            default:
                statuStr = "";
           }
            return statuStr
        },
        //点击显示隐藏密码执行函数
        changePasswordShow(){
            if(this.addPassword.passwordImg === this.addPassword.showPassword){
                this.addPassword.passwordImg = this.addPassword.hidePassword;
                this.addPassword.passwordFlage = "password";
            }else{
                this.addPassword.passwordImg = this.addPassword.showPassword;
                this.addPassword.passwordFlage = "text";
            }
        },
        addPasswordSetting(){
            this.addPassword.addPasswordFrom = true;
            this.addPassword.title = "";
            this.addPassword.payload = "";
            this.addPassword.locks = "";
            this.addPassword.countLimit = "";
            this.addPassword.countLimitDis = false;
            this.addPassword.Unlinmited = false;
            this.addPassword.startTime = "";
            this.addPassword.endTime = "";
            this.addPassword.isFovever = false;
            this.addPassword.fovever = false;
            this.addPassword.devList.map(item =>{
                item.isChecked = false;
            })
        },
        //添加Password 不限次数开关改变函数
        addPasswordUnlinmitChage(item){
            if(item){
                this.addPassword.countLimit = "";
                this.addPassword.countLimitDis = true;
            }else{
                this.addPassword.countLimitDis = false;
            }
        },
        //添加Password 永久有效开关改变函数
        addPasswordForeverChage(item){
            if(item){
                this.addPassword.startTime = "";
                this.addPassword.endTime = "";
                this.addPassword.isFovever = true;
            }else{
                this.addPassword.isFovever = false;
            }
        },
      
        //添加PasswordUnlock配置点击确定执行函数
        addPasswordUnlock(){
            let checkCardName = this.$regularCheckLimit(this.addPassword.title,1,64,'NameCannotEmpty');
            if(!checkCardName){
                return false
            }
            if(this.addPassword.payload === ""){
                this.$message.info(this.$t('UnlockPasswordEmpty'));
                return false
            }
            let checkPasswordRegex = /^\d{4,12}$/;
            if(!checkPasswordRegex.test(this.addPassword.payload)){
                this.$message.info(this.$t('PasswordUnlockLimit'));
                return false
            }
            if(this.addPassword.locks.length == 0){
                this.$message.info(this.$t('UnlockOptionEmpty'));
                return false
            }
            let finCountLimit = 0;
            if(this.addPassword.Unlinmited){
                finCountLimit = 0;
            }else{
                // if(this.addPassword.countLimit === ""){
                //     this.$message.info(this.$t('LimitedEmpty'));
                //     return false
                // }else{
                //     if(Number(this.addPassword.countLimit) > 999){
                //         this.$message.info(this.$t('LimitUnlockNum').replace('100','999'));
                //         return false
                //     }
                // }
                let countLimitReg = /^([1-9][0-9]{0,2})$|^[1-9]$/;
                if(!countLimitReg.test(this.addPassword.countLimit)){
                    this.$message.info(this.$t('LimitUnlockNumLimit'));
                    return false
                }
                finCountLimit = this.addPassword.countLimit;
            }
            let finStartTime = 0;
            let finEndTime = 0;
            if(this.addPassword.fovever){
                finStartTime = 0;
                finEndTime = 0;
            }else{
                if(this.addPassword.startTime == null){
                    this.addPassword.startTime = "";
                }
                if(this.addPassword.endTime == null){
                    this.addPassword.endTime = "";
                }
                if(this.addPassword.startTime === ""){
                    this.$message.info(this.$t('StartTimeEmptye'));
                    return false
                }
                if(this.addPassword.endTime === ""){
                    this.$message.info(this.$t('EndTimeEmptye'));
                    return false
                }
                if(this.addPassword.startTime != "" && this.addPassword.endTime != ""){
                    if(this.addPassword.startTime >= this.addPassword.endTime){
                        this.$message.info(this.$t('StartTimeLaterEndTime'));
                        return false
                    }
                }
                finStartTime = this.addPassword.startTime;
                finEndTime = this.addPassword.endTime;

            }
            let finDevArr = [];
            this.addPassword.devList.map(item =>{
                if(item.isChecked){
                    finDevArr.push(item.id)
                }
            })
            if(finDevArr.length === 0){
                this.$message.info(this.$t('PleaseSelectPanels'));
                return false
                
            }
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            let encryStr = encryptCBC(this.addPassword.payload,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            let nowTimeTamp = new Date().getTime();
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let addUserPasswordObj = {
                "type": 1,
                "userHouseId":this.updateSiteUser.id,
                // "userId":this.updateSiteUser.userId,
                "checkKeyId": nowTimeTamp, 
                "title": this.addPassword.title,
                "payload": this.base64ToHex(encryStr),
                "payloadSha": CryptoJS.SHA256(this.addPassword.payload),
                // "cardType": 24,
                "locks": this.addPassword.locks.join(","),
                "countLimit": finCountLimit,
                "startTime": finStartTime,
                "endTime": finEndTime,
                "entranceDeviceIds": finDevArr,
                "timestamp": nowTimeTamp,
                "createTime": nowTimeTamp,
            };
            // console.log("addUserPasswordObj",addUserPasswordObj);
            // return false
            const sortedData = Object.keys(addUserPasswordObj)
                    .sort()
                    .map(key => `${key}=${addUserPasswordObj[key]}`)
                    .join("&");
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userHouseId', this.updateSiteUser.id);
            formData.append('userId', this.updateSiteUser.userId);
            formData.append('type', 1);
            formData.append('checkKeyId', nowTimeTamp);
            formData.append('title', this.addPassword.title);
            formData.append('payload', this.base64ToHex(encryStr));
            formData.append('payloadSha', CryptoJS.SHA256(this.addPassword.payload));
            // formData.append('cardType', 24);
            formData.append('locks', this.addPassword.locks.join(","));
            formData.append('countLimit', finCountLimit);
            formData.append('startTime', finStartTime);
            formData.append('endTime', finEndTime);
            formData.append('entranceDeviceIds', finDevArr);
            formData.append('timestamp', nowTimeTamp);
            formData.append('createTime', nowTimeTamp);
            formData.append('sign', this.Hmacstr(sortedData,this.updateSiteUser.id));
            this.addPassword.addBtnState = 1;
            sitesUsersApi.addSiteUserCardConfig(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('AddSuccessful'));
                    this.addPassword.addBtnState = 0;
                    //获取uesr Password 配置列表
                    this.getSiteUserPasswordList();
                    this.addPassword.addPasswordFrom = false;
                }else{
                    this.addPassword.addBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.addPassword.addBtnState = 0;
            })
        },
        //密码开锁列表点击编辑
        editPasswordSetting(item){
            this.editPassword.editPasswordFrom = true;
            let passwordInfoObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let passwordPostObj = {
                "userHouseId":this.updateSiteUser.id,
                "entranceKeyId":item.entranceKeyId,
                "userId":item.userId,
            }
            sitesUsersApi.getSiteUserCardDetail(passwordInfoObj,passwordPostObj).then(res => {
                if(res.code === 0){
                   this.editPassword.title = res.data.title;
                   //将tdk+userHouseId使用SHA256生成AES加密KEY
                   let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
                   //把获取到的16进制的字符串转为base64
                   let base64Str = this.hexStringToBase64(res.data.payload);
                   //解密之后得密码
                   let cardNumHex = decryptCBC(base64Str,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
                   this.editPassword.payload = cardNumHex;
                   this.editPassword.userId = res.data.userId;
                   this.editPassword.entranceKeyId = res.data.entranceKeyId;
                   this.editPassword.locks = (res.data.locks).split(",");
                   if(res.data.countLimit === 0){
                       this.editPassword.countLimit = "";
                       this.editPassword.countLimitDis = true;
                       this.editPassword.Unlinmited = true;
                   }else{
                       this.editPassword.countLimitDis = false;
                       this.editPassword.Unlinmited = false;
                       this.editPassword.countLimit = res.data.countLimit;
                   }
                   if(res.data.startTime === 0 && res.data.endTime === 0){
                       this.editPassword.startTime = "";
                       this.editPassword.endTime = "";
                       this.editPassword.isFovever = true;
                       this.editPassword.fovever = true;
                   }else{
                       this.editPassword.startTime = res.data.startTime;
                       this.editPassword.endTime = res.data.endTime;
                       this.editPassword.isFovever = false;
                       this.editPassword.fovever = false;
                   }
                   this.editPassword.entranceDeviceList = res.data.entranceDeviceList;
                   this.editPassword.devList.map(item=>{
                        item.isChecked = false;
                        if (item.hasOwnProperty('applyStatus')) {
                            delete item.applyStatus
                        }
                    })
                    // console.log("this.editPassword.entranceDeviceList",this.editPassword.entranceDeviceList)
                    this.editPassword.devList.map(item=>{
                        this.editPassword.entranceDeviceList.map(item2=>{
                            if(item.id === item2.entranceDeviceId){
                                item.isChecked = true;
                                item.applyStatus = item2.applyStatus;
                            }
                        })
                    })
                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
            })
            
        },
        //编辑Password 不限次数开关改变函数
        editPasswordUnlinmitChage(item){
            if(item){
                this.editPassword.countLimit = "";
                this.editPassword.countLimitDis = true;
            }else{
                this.editPassword.countLimitDis = false;
            }
        },
        //编辑Password 永久有效开关改变函数
        editPasswordForeverChage(item){
            if(item){
                this.editPassword.startTime = "";
                this.editPassword.endTime = "";
                this.editPassword.isFovever = true;
            }else{
                this.editPassword.isFovever = false;
            }
        },

        //编辑Password确认
        editPasswordUnlock(){
            let checkCardName = this.$regularCheckLimit(this.editPassword.title,1,64,'NameCannotEmpty');
            if(!checkCardName){
                return false
            }
            if((this.editPassword.payload.toString()).trim() === ""){
                this.$message.info(this.$t('UnlockPasswordEmpty'));
                return false
            }
            if(this.editPassword.locks.length == 0){
                this.$message.info(this.$t('UnlockOptionEmpty'));
                return false
            }
            let finCountLimit = 0;
            if(this.editPassword.Unlinmited){
                finCountLimit = 0;
            }else{
                // if(this.editPassword.countLimit === ""){
                //     this.$message.info(this.$t('LimitedEmpty'));
                //     return false
                // }else{
                //     if(Number(this.editPassword.countLimit) > 999){
                //         this.$message.info(this.$t('LimitUnlockNum').replace('100','999'));
                //         return false
                //     }
                // }
                let countLimitReg = /^([1-9][0-9]{0,2})$|^[1-9]$/;
                if(!countLimitReg.test(this.editPassword.countLimit)){
                    this.$message.info(this.$t('LimitUnlockNumLimit'));
                    return false
                }
                finCountLimit = this.editPassword.countLimit;
            }
            let finStartTime = 0;
            let finEndTime = 0;
            if(this.editPassword.fovever){
                finStartTime = 0;
                finEndTime = 0;
            }else{
                if(this.editPassword.startTime == null){
                    this.editPassword.startTime = "";
                }
                if(this.editPassword.endTime == null){
                    this.editPassword.endTime = "";
                }
                if(this.editPassword.startTime === ""){
                    this.$message.info(this.$t('StartTimeEmptye'));
                    return false
                }
                if(this.editPassword.endTime === ""){
                    this.$message.info(this.$t('EndTimeEmptye'));
                    return false
                }
                if(this.editPassword.startTime != "" && this.editPassword.endTime != ""){
                    if(this.editPassword.startTime >= this.editPassword.endTime){
                        this.$message.info(this.$t('StartTimeLaterEndTime'));
                        return false
                    }
                }
                finStartTime = this.editPassword.startTime;
                finEndTime = this.editPassword.endTime;

            }
            let finDevArr = [];
            this.editPassword.devList.map(item =>{
                if(item.isChecked){
                    finDevArr.push(item.id)
                }
            })
            if(finDevArr.length === 0){
                this.$message.info(this.$t('PleaseSelectPanels'));
                return false
                
            }
            //将tdk+userHouseId使用SHA256生成AES加密KEY
            let payloadKey = CryptoJS.SHA256("tdk"+this.updateSiteUser.id);
            // 先转16进制 在加密 
            // let finCardNum = this.decimalToHex(Number(this.editPassword.payload));
            let encryStr = encryptCBC(this.editPassword.payload,payloadKey,CryptoJS.enc.Hex.parse(this.byteToHex(new Uint8Array(16))));
            let nowTimeTamp = new Date().getTime();
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let editUserPasswordObj = {
                "type": 1,
                "userHouseId":this.updateSiteUser.id,
                "entranceKeyId":this.editPassword.entranceKeyId,
                // "checkKeyId": new Date().getTime(), 
                "title": this.editPassword.title,
                // "payload": this.base64ToHex(encryStr),
                // "cardType": 24,
                "locks": this.editPassword.locks.join(","),
                "countLimit": finCountLimit,
                "startTime": finStartTime,
                "endTime": finEndTime,
                "entranceDeviceIds": finDevArr,
                "timestamp": nowTimeTamp,
            };
            const sortedData = Object.keys(editUserPasswordObj)
                    .sort()
                    .map(key => `${key}=${editUserPasswordObj[key]}`)
                    .join("&");
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userHouseId', this.updateSiteUser.id);
            formData.append('userId', this.updateSiteUser.userId);
            formData.append('entranceKeyId', this.editPassword.entranceKeyId);
            formData.append('type', 1);
            formData.append('checkKeyId', nowTimeTamp);
            formData.append('title', this.editPassword.title);
            // formData.append('payload', this.base64ToHex(encryStr));
            // formData.append('cardType', 24);
            formData.append('locks', this.editPassword.locks.join(","));
            formData.append('countLimit', finCountLimit);
            formData.append('startTime', finStartTime);
            formData.append('endTime', finEndTime);
            formData.append('entranceDeviceIds', finDevArr);
            formData.append('timestamp', nowTimeTamp);
            formData.append('sign', this.Hmacstr(sortedData,this.updateSiteUser.id));
            this.editPassword.editBtnState = 1;
            sitesUsersApi.updateSiteUserCardConfig(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('UpdateSuccessfully'));
                    this.editPassword.editBtnState = 0;
                    //获取uesr Password 配置列表
                    this.getSiteUserPasswordList();
                    this.editPassword.editPasswordFrom = false;
                }else{
                    this.editPassword.editBtnState = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.editPassword.editBtnState = 0;
            })
        },
        //删除Password弹窗
        openDelPasswordFrom(item){
            this.delPassword.delPasswordFrom = true;
            this.delPassword.entranceKeyId = item.entranceKeyId;
        },
        //删除Password 确认
        delPasswordSetting(){
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            const delSiteUserPasswordObj = {}
            delSiteUserPasswordObj.entranceKeyId = [];
            delSiteUserPasswordObj.entranceKeyId.push(this.delPassword.entranceKeyId);
            delSiteUserPasswordObj.userHouseId = this.updateSiteUser.id;
            delSiteUserPasswordObj.userId = this.updateSiteUser.userId;
            this.delPassword.delBtnState = 1;
            sitesUsersApi.delSiteUserCard(rgnObj,delSiteUserPasswordObj).then(res => {
                if(res.code === 0){
                    this.delPassword.delBtnState = 0;
                    this.$message.success(this.$t('DeleteSuccessfully'));
                    this.delPassword.delPasswordFrom = false;
                    //获取uesr Password 配置列表
                    this.getSiteUserPasswordList();
                }else{
                    this.delPassword.delBtnState = 0;
                    this.$handerrcode(res.code);
                }
                
            }).catch((err) => {
                this.delPassword.delBtnState = 0;
                console.log('err', err);
            })
            
        },
    },
    computed:{
        ...mapState(["selectCompany","selectSite"])
    },
    watch:{
      
    }
}
</script>

<style scoped>
.addsiteUersBox{
    display: flex;
}
.addSiteUserLeft{
    width: 50%;
    padding-right: 1vw;
}
.NameBox{
    display: flex;
    justify-content: space-between;
}

.addSiteUserRight{
    width: 50%;
    font-size: 18px !important;
    margin-left: 2vw;
}
.addSiteUserRight p {
    font-size: 16px;
    color: #CFCFCF;
}
.addSiteUserRight p span{
    color: #6498b5;
}
::v-deep .addSiteUserRight .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 100%;
    border: none;
    background: #EFEFEF;
}
.licenseBox{
    background: #EFEFEF;
    margin-top: 1vw;
    padding: 1vw 1vw;
    height: 105px;
    overflow-y: auto;
    border-radius: 10px;
}
.LimitContent{
    border-top:1px solid #ddd;
    /* border-radius: 8px; */
    padding-bottom: 15px;
}
.LimitBox{
    display: flex;
    justify-content: space-between;
    height: 45px;
}
::v-deep .LimitBox label{
    margin-top: 10px !important;
}
.FoveverBox{
    display: flex;
    justify-content: space-between;
    height: 45px;
}
.cardText{
    width:48%;
    text-align: right;
    padding-right: 20px; 
    margin-top: 20px;color: #333;
}
::v-deep .el-form-item__label{
    text-align: left;
}
.addCard .el-button--primary {
    margin-left: 60px !important;
    color: #fff;
    background-color: #6498b5;
    border-color: #6498b5;
}
</style>